import type { ProductLogoSmallProps } from '../types';

export function ProductLogoSmallPublicIDs({
  size = 20,
  color = '#0070C0',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M213.187 193.214C213.187 219.053 192.241 240 166.401 240C140.562 240 119.615 219.053 119.615 193.214C119.615 167.375 140.562 146.428 166.401 146.428C192.241 146.428 213.187 167.375 213.187 193.214Z"
        fill={color}
      />
      <path
        d="M84.5259 313.659C84.5259 285.898 107.031 263.393 134.792 263.393H198.011C225.772 263.393 248.277 285.898 248.277 313.659V325.194C248.277 329.821 244.526 333.572 239.899 333.572H92.9036C88.2767 333.572 84.5259 329.821 84.5259 325.194V313.659Z"
        fill={color}
      />
      <path
        d="M272.644 181.518C272.644 175.058 277.881 169.821 284.341 169.821H377.913C384.372 169.821 389.609 175.058 389.609 181.518C389.609 187.977 384.372 193.214 377.913 193.214H284.341C277.881 193.214 272.644 187.977 272.644 181.518Z"
        fill={color}
      />
      <path
        d="M272.644 240C272.644 233.54 277.88 228.304 284.34 228.304H376.996C383.456 228.304 388.693 233.54 388.693 240C388.693 246.46 383.456 251.697 376.996 251.697H284.34C277.88 251.697 272.644 246.46 272.644 240Z"
        fill={color}
      />
      <path
        d="M272.644 298.482C272.644 292.023 277.88 286.786 284.34 286.786H376.996C383.456 286.786 388.693 292.023 388.693 298.482C388.693 304.942 383.456 310.179 376.996 310.179H284.34C277.88 310.179 272.644 304.942 272.644 298.482Z"
        fill={color}
      />
      <path
        d="M30 101.382C30 87.5015 41.2525 76.249 55.1331 76.249H61.1906V107.44H30V101.382Z"
        fill={color}
      />
      <path
        d="M418.809 76.249H424.867C438.748 76.249 450 87.5015 450 101.382V107.44H418.809V76.249Z"
        fill={color}
      />
      <path
        d="M30 372.56H61.1906V403.751H55.1331C41.2525 403.751 30 392.498 30 378.618V372.56Z"
        fill={color}
      />
      <path
        d="M418.809 403.751V372.56H450V378.618C450 392.498 438.747 403.751 424.867 403.751H418.809Z"
        fill={color}
      />
      <path d="M61.1906 76.249H418.809V107.44H61.1906V76.249Z" fill={color} />
      <path
        d="M61.1906 372.56L418.809 372.56V403.751L61.1906 403.751V372.56Z"
        fill={color}
      />
      <path d="M30 107.44H61.1906V372.56H30V107.44Z" fill={color} />
      <path d="M418.809 107.44H450V372.56H418.809V107.44Z" fill={color} />
    </svg>
  );
}
